import React from "react";
import Button from "react-bootstrap/Button";

const MyProject = () => {
  return (
    <div className='project-content-container'>
      <div className='project-content'>
        <h2>My Project </h2>
        <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy.
        </p>

        <div className='project-box'>
          <div className='project-box-item'>
            <h2>Project</h2>
            <h2>Date</h2>
            <h2>Developer</h2>
          </div>
          <div className='project-box-item'>
            <h4>DashBoard </h4>
            <p>11/05/2023</p>
            <span>John</span>
          </div>
          <div className='project-box-item'>
            <h4>Template </h4>
            <p>11/05/2023</p>
            <span>John</span>
          </div>
          <div className='project-box-item'>
            <h4>DashBoard </h4>
            <p>11/05/2023</p>
            <span>John</span>
          </div>
        </div>
      </div>
      <div className='project-content-card'>
        <h2> Plan</h2>

        <div className='project-plan-box'>
          {/* <div className='project-box'>
            <div className='project-box-item'>
              <h2>Start Date</h2>
              <h2>End Date</h2>
              <h2>Status</h2>
            </div>
            <div className='project-box-item'>
              <h4>11/05/2023 </h4>
              <p>12/05/2023</p>
              <span>---</span>
            </div>
            <div className='project-box-item'>
              <h4>11/05/2023 </h4>
              <p>12/05/2023</p>
              <span>---</span>
            </div>
            <div className='project-box-item'>
              <h4>11/05/2023 </h4>
              <p>12/05/2023</p>
              <span>---</span>
            </div>
            <Button className='cta-btn'>Upgrade Plan</Button>
          </div> */}
          <div className='project-plan-type'>
            <span>Plan</span>
            <h4>Business</h4>
          </div>

          <div className='project-plan-status'>
            <span>Status</span>
            <h4>Active </h4>
          </div>
          <div className='project-plan-exp'>
            <span>End Date</span>
            <h4>31/05/ 2023</h4>
          </div>
          <div className='project-plan-button'>
            <Button className='cta-btn'>Upgrade Plan</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProject;
